var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.box},[_c('div',{class:_vm.$style.content,style:({ height: _vm.dialogHeight, marginTop: _vm.dialogMarginTop })},[_c('div',{class:_vm.$style.title},[_vm._t("title")],2),_c('div',{class:_vm.$style.main},[_vm._t("main-content")],2),_c('div',{class:_vm.$style.footer},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }